import React from "react";

export function FooterCompact({
  today,
  footerClasses,
  footerContainerClasses,
}) {
  return (
    <>
      {/* begin::Footer */}
      <div
        className={`footer bg-white py-4 d-flex flex-lg-column  ${footerClasses}`}
        id="kt_footer"
      >
        {/* begin::Container */}
        <div
          className={`${footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-center`}
        >
          <div className="row text-dark order-2 order-md-1">
          <div className="col-md-6">
               <ul className="footer-nav list-inline">
                  <li className="list-inline-item"><a href="https://k1order.k1ple.com:34002/terms/policy">이용약관 </a></li>
                  <li className="list-inline-item"><a href="https://k1order.k1ple.com:34002/terms/privacy">개인정보처리방침</a></li>
               </ul>
               <hr/>
               <p style={{'margin': 0}}>고객센터</p>
               <p style={{'margin': 0, 'color': '#808080'}}>카카오톡 : @키오더문의</p>
               <p style={{'margin': 0, 'color': '#808080'}}>메일 : info@k1ple.com</p>
               <p className={'d-none'} style={{'margin': 0, 'color': '#808080'}}>대표번호 : 031-216-8771</p>
               <span className="small" style={{'color': '#808080'}}>사용중 문의사항은 언제든 지체없이 연락해주시기 바랍니다~</span>
            </div>
            <div className="col-md-6">
              <span className="text-muted font-weight-bold mr-2">
                {today} &copy;
              </span>
            {` `}
            <a
              href="https://k1order.k1ple.com/intro"
              rel="noopener noreferrer"
              target="_blank"
              className="text-dark-75 text-hover-primary"
            >
              k1order
            </a>
               {/* <p class="copyright">k1ple &copy; 2023</p> */}
               <hr/>
               <p style={{'margin': 0, 'color': '#808080'}}><strong>주식회사 키플</strong> | 대표 이경진</p>
               <p style={{'margin': 0, 'color': '#808080'}}>사업자 등록번호 828-86-01610 | 통신판매신고 제2023-수원영통-0674호</p>
               <p style={{'margin': 0, 'color': '#808080'}}>경기도 수원시 영통구 대학4로 17, 608-1호 (이의동, 에이스광교타워1)</p>
               <p style={{'margin': 0, 'color': '#808080'}}>호스팅서비스 제공자 : AWS Web service, Inc</p>
               <span className="small" style={{'color': '#808080'}}>키플은 모든 거래에 대한 책임과 배송, 교환, 환불 민원등의 처리는 키플에서 진행합니다. 민원 담당자 이경진 / 연락처 010-5238-2770</span>
          </div>
        {/* end::Container */}
        </div>
      </div>
      </div>
      {/* end::Footer */}
    </>
  );
}
